import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import usePrice from 'src/hooks/usePrice';
import { previewAccessorySelector } from 'src/redux/configurator/selectors';
import { formatFittingTime } from 'helpers/utilities';
import Wrench from 'src/assets/icons/wrench.svg';
import Carousel from 'components/_utility/Carousel/Carousel';
import Label from 'components/_utility/Label';
import TriumphTriangle from 'src/assets/icons/triumph-triangle.svg';
import { closeModal } from 'src/redux/configurator/actions';
import cloudinary from 'helpers/cloudinary';
import {
  Wrap,
  Info,
  Name,
  PartNumber,
  PartNumberWrap,
  Description,
  TotalWrap,
  Price,
  Fitting,
  FittingTime,
  Slide,
  PlaceholderImageWrap,
  AddAccessoryButton,
} from './AccessoryInfoModal.styled';

const AccessoryInfoModal = () => {
  const dispatch = useDispatch();
  const selectedPreviewAccessory = useSelector(previewAccessorySelector);
  const { feeDisclaimer, provincialFee, selectedProvince, provincePricingEnabled } = selectedPreviewAccessory || {};
  const formatPrice = usePrice();

  return (
    <Wrap>
      <>
        {selectedPreviewAccessory.images.length ? (
          <Carousel
            slides={selectedPreviewAccessory.images.map(image => {
              const imageUrl = window.encodeURI(cloudinary(image.src, 'c_thumb,w_700'));

              return <Slide style={{ backgroundImage: `url("${imageUrl}")` }} />;
            })}
          />
        ) : (
          <PlaceholderImageWrap>
            <TriumphTriangle />
          </PlaceholderImageWrap>
        )}
      </>
      <Info>
        <Name>{selectedPreviewAccessory.name || selectedPreviewAccessory.title}</Name>
        {selectedPreviewAccessory.partNumber && (
          <PartNumberWrap>
            <Label name="partNumberLabel" />
            <PartNumber>{selectedPreviewAccessory.partNumber}</PartNumber>
          </PartNumberWrap>
        )}
        <Description
          dangerouslySetInnerHTML={{
            __html: selectedPreviewAccessory.description,
          }}
        />
        {(!provincePricingEnabled || (provincePricingEnabled && selectedProvince)) && (
          <TotalWrap>
            <Price hasFittingTime={!!selectedPreviewAccessory.fittingTime}>
              {(() => {
                if (provincialFee !== undefined && selectedProvince) {
                  return formatPrice(provincialFee);
                }
                if (selectedPreviewAccessory.price) {
                  return formatPrice(Number(selectedPreviewAccessory.price));
                }
                return selectedPreviewAccessory.priceLocalised;
              })()}
            </Price>
            {selectedPreviewAccessory.fittingTime && (
              <>
                <Wrench></Wrench>
                <Fitting>
                  <FittingTime>{formatFittingTime(selectedPreviewAccessory.fittingTime)}</FittingTime>
                </Fitting>
              </>
            )}
          </TotalWrap>
        )}
        {!feeDisclaimer && (
          <AddAccessoryButton
            onClick={() => {
              dispatch(closeModal('accessories'));
              selectedPreviewAccessory.onSelectCard(selectedPreviewAccessory.id);
            }}
          >
            {selectedPreviewAccessory.selected ? (
              <>
                <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.44912 9.1786L1.13019 5.75802L0 6.91462L4.44912 11.5L14 1.6566L12.8778 0.5L4.44912 9.1786Z"
                    fill="white"
                  />
                </svg>
                <Label name="added" />
              </>
            ) : (
              <Label name="addAccessory" />
            )}
          </AddAccessoryButton>
        )}
      </Info>
    </Wrap>
  );
};

export default AccessoryInfoModal;
